export default Object.freeze({
  MDM_STORESTOCK_ERROR: 'MDM_STORESTOCK_ERROR',
  CHECKOUT_FILTER: 'CHECKOUT_FILTER',
  MDM_REFRESH_TOKEN: 'MDM_REFRESH_TOKEN',
  MDM_ADD_GIFT_CARD_ERROR: 'MDM_ADD_GIFT_CARD_ERROR',
  ADD_GIFT_CART: 'ADD_GIFT_CART'
});